// extracted by mini-css-extract-plugin
export default {"editSubscribe":"EditSubscribe_editSubscribe__bLJxs","editSubscribeForm":"EditSubscribe_editSubscribeForm__n5zX8"};